
<!-- 用户信息-->
<template>
  <div>
    <x-userInfo apiOrigin="JAVA"></x-userInfo>
  </div>
</template>

<script>
import { userInfo } from 'ant-design-vue-admin-x';
export default {
  name: 'userInfo',
  components: { XUserInfo: userInfo }
};
</script>
